/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { useCallback, useEffect, useMemo, useRef, useState } from "react";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";

// Images
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";

import DataTable from "examples/Tables/DataTable";
import {
  Button,
  Card,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Icon,
  Menu,
  MenuItem,
  Switch,
} from "@mui/material";
import applicator from "ajv/dist/vocabularies/applicator";
import colors from "assets/theme/base/colors";
import { useNavigate } from "react-router-dom";
import NotificationItem from "examples/Items/NotificationItem";
import moment from "moment";
import debounce from "lodash.debounce";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { exportToExcel } from "utilities";
import { NumberFormatter } from "utilities";
import { fairStatus } from "utilities";
import { statusColors, leadColors } from "utilities";
import { notify } from "utilities";
import { deleteUser } from "api";
import { updateUser } from "api";
import { getAllAttendees } from "api";
import { getAllCheckIn } from "api";
import { getAllLocationList } from "api";

// import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import dayjs from "dayjs";

export default function data({ fair, locationData, registration }) {
  const navigate = useNavigate();

  const [list, setList] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(50);

  const [menuAnchor, setMenuAnchor] = useState(null);
  const [currentRowId, setCurrentRowId] = useState(null);

  const [loading, setLoading] = useState(false);

  const [search, setSearch] = useState();
  const [loadingId, setLoadingId] = useState(null);

  const arrStatus = [
    { key: "all", name: "All" },
    { key: "yes", name: "Yes" },
    { key: "no", name: "No" },
  ];
  const [counselled, setCounselled] = useState(arrStatus[0]);

  const [openConfirm, setOpenConfirm] = useState(false);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [arrLocation, setArrLocation] = useState([{ _id: 0, name: "All" }]);
  const [location, setLocation] = useState(locationData || arrLocation[0]);

  const [arrIntake, setArrIntake] = useState([{ key: "all", name: "All" }]);
  const [intake, setIntake] = useState(arrIntake[0]);

  const [arrLead, setArrLead] = useState([{ key: "all", name: "All" }]);
  const [leadType, setLeadType] = useState(arrLead[0]);
  const [country, setCountry] = useState("");

  const lastSearch = useRef("");
  const isFetching = useRef(false);
  const lastApiParams = useRef("");
  const resizeTimeout = useRef(null);
  const didMount = useRef(false);
  const isFirstLoad = useRef(true);

  // useEffect(() => {}, [loadingId]);

  useEffect(() => {
    const handleResize = () => {
      clearTimeout(resizeTimeout.current);
      resizeTimeout.current = setTimeout(() => {
        // do nothing → just absorb resize re-renders
      }, 300);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const currentYear = new Date().getFullYear();

    // const years = Array.from({ length: currentYear - 1900 + 1 }, (_, index) => {
    //   const year = 1900 + index;
    //   return { key: `${year}`, name: year.toString() };
    // });

    const years = [
      "All",
      "Jan 26",
      "Feb 26",
      "Jul 26",
      "Sep 26",
      "Jan 27",
      "Feb 27",
      "Jul 27",
      "Sep 27",
      "Jan 28",
      "Feb 28",
      "Jul 28",
      "Sep 28",
      "Not Decided",
    ];
    const yearOptions = years.map((item) => ({
      key: item.replace(/\s+/g, "_").toLowerCase(), // e.g. "jan_26"
      name: item, // keep original label
    }));

    // console.log("____yearOptions_______", yearOptions);

    setArrIntake(yearOptions);
    setIntake(yearOptions[0]);

    const leads = ["All", "Hot Lead", "Cold Lead", "Warm Lead"];
    const leadOptions = leads.map((item) => ({
      key: item.replace(/\s+/g, "_").toLowerCase(), // e.g. "jan_26"
      name: item, // keep original label
    }));

    // console.log("____yearOptions_______", yearOptions);

    // setArrLead([leadType, ...leadOptions]);
    setArrLead(leadOptions);
    setLeadType(leadOptions[0]);

    // onSearchData("");
    if (didMount.current) return;

    didMount.current = true;
    getAllCheckInApi();

    getAllLocationApi();
  }, []);

  useEffect(() => {
    if (isFirstLoad.current) {
      isFirstLoad.current = false;
      return;
    }

    getAllCheckInApi();
  }, [search]);

  const debouncedFetch = useMemo(
    () =>
      debounce((searchVal) => {
        setSearch(searchVal);
      }, 500),
    []
  );

  useEffect(() => {
    return () => {
      debouncedFetch.cancel();
    };
  }, [debouncedFetch]);

  useEffect(() => {
    getAllCheckInApi();
  }, [page]);

  const getAllCheckInApi = (isReset = false, isExport = false) => {
    var params = {
      page: page,
      limit: limit,
      name: search,
      fair: fair?._id,
      isExport: isExport,
    };

    if (registration) {
      params.attendee = registration;
    }

    if (isReset) {
      params.location = "all";
      params.intake = "all";
      params.startDate = "";
      params.endDate = "";
      params.leadType = "all";
      params.counselled = "all";
      params.country = "";
    } else {
      params.location = location?._id || "all";
      params.intake = intake?.name || "all";
      params.startDate = startDate || "";
      params.endDate = endDate || "";
      params.leadType = leadType?.name || "all";
      params.counselled = counselled?.key || "all";
      params.country = country || "";
    }

    const key = JSON.stringify(params);

    // 🚀 BLOCK if same API already called
    if (lastApiParams.current === key) return;

    lastApiParams.current = key;

    if (isFetching.current) return; // 🚀 BLOCK duplicate calls
    isFetching.current = true;

    setLoading(true);

    getAllCheckIn({
      params: params,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
          } else {
            if (isExport) {
              const dataList = responseJson?.attendees;
              exportToExcel(dataList, "checkIn.xlsx");
            } else {
              setList(responseJson?.attendees || []);
              setTotal(responseJson?.total || 0);
            }
          }
        }
      })
      .catch((e) => {})
      .finally(() => {
        setLoading(false);
        isFetching.current = false;
      });
  };

  const getAllLocationApi = () => {
    var params = {
      page: 1,
      limit: 1000,
      fair: fair?._id,
    };

    getAllLocationList({
      params: params,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
          } else {
            setArrLocation([{ _id: 0, name: "All" }, ...responseJson?.location]);
            if (locationData) {
              setLocation(responseJson?.location.find((loc) => loc._id === locationData?._id));
            }
          }
        }
      })
      .catch((e) => {})
      .finally(() => {});
  };

  const onSearchData = (val) => {
    if (lastSearch.current === val) return; // 🚀 STOP duplicate
    lastSearch.current = val;
    setPage(1);
    debouncedFetch(val);
  };

  const handleAction = (event, rowId) => {
    // setMenuAnchor(event.currentTarget);
    // setCurrentRowId(rowId);
  };

  const closeMenu = () => {
    setMenuAnchor(null);
  };

  const columns = useMemo(() => {
    return [
      { Header: "name", accessor: "name", align: "left" },
      { Header: "contact", accessor: "contact", align: "center" },
      { Header: "location", accessor: "location", align: "center" },
      {
        Header: "checked-in",
        accessor: "checkedIn",
        align: "center",
      },
      { Header: "graduation", accessor: "graduation", align: "center" },
      { Header: "Preferred Country", accessor: "country", align: "center" },
      // { Header: "parent contact", accessor: "parent", align: "center" },
      { Header: "intake year", accessor: "intakeYear", align: "center" },
      {
        Header: "lead",
        accessor: "lead",
        align: "center",
      },
      {
        Header: "counselled",
        accessor: "counselled",
        align: "center",
      },
      { Header: "note", accessor: "note", align: "center" },
    ];
  }, []);

  const rows = useMemo(() => {
    var rowsData = [];

    list.map((item) =>
      rowsData.push({
        name: (
          <MDBox>
            <MDTypography
              display="block"
              variant="button"
              fontWeight="medium"
              noWrap
              sx={{
                maxWidth: "350px",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {item?.attendee?.name}
            </MDTypography>
            <MDTypography display="block" variant="caption">
              <b>City:</b> {item?.attendee?.city}
            </MDTypography>
            <MDTypography display="block" variant="caption">
              {item?.attendee?._id}
            </MDTypography>
          </MDBox>
        ),
        contact: (
          <MDBox sx={{ px: 1, textAlign: "left", minWidth: 200 }}>
            <MDTypography display="block" variant="caption" noWrap>
              {item?.attendee?.code} {item?.attendee?.phone}
            </MDTypography>
            <MDTypography display="block" variant="caption" noWrap>
              {item?.attendee?.email}
            </MDTypography>
          </MDBox>
        ),
        location: (
          <MDBox sx={{ px: 1 }}>
            <MDTypography display="block" variant="caption" noWrap>
              {item?.location?.name}
            </MDTypography>
          </MDBox>
        ),
        checkedIn: (
          <MDBox sx={{ px: 1, textAlign: "left" }}>
            <MDTypography display="block" variant="caption" noWrap>
              {moment(item?.createdAt).format("DD MMM YYYY, hh:mm a")}
            </MDTypography>
          </MDBox>
        ),
        graduation: (
          <MDBox sx={{ px: 1, textAlign: "left" }}>
            <MDTypography display="block" variant="caption" noWrap>
              {item?.graduation ||
                item?.attendee?.checkIn?.graduation ||
                item?.attendee?.graduation}
            </MDTypography>
          </MDBox>
        ),
        country: (
          <MDBox sx={{ px: 1, textAlign: "left" }}>
            <MDTypography display="block" variant="caption" noWrap>
              {/* {item?.country || item?.attendee?.checkIn?.country} */}
              {item?.attendee?.checkIn?.country}
            </MDTypography>
          </MDBox>
        ),
        // parent: (
        //   <MDBox sx={{ px: 1, textAlign: "left", minWidth: 150 }}>
        //     <MDTypography display="block" variant="caption" noWrap>
        //       {item?.parentName || item?.attendee?.checkIn?.parentName}
        //     </MDTypography>
        //     <MDTypography display="block" variant="caption" noWrap>
        //       {item?.parentCountryCode || item?.attendee?.checkIn?.parentCountryCode}{" "}
        //       {item?.parentPhone || item?.attendee?.checkIn?.parentPhone}
        //     </MDTypography>
        //     {(item?.intakeYear || item?.attendee?.checkIn?.intakeYear) && (
        //       <MDTypography display="block" variant="caption" noWrap>
        //         <b>Intake Year:</b> {item?.intakeYear || item?.attendee?.checkIn?.intakeYear}
        //       </MDTypography>
        //     )}
        //   </MDBox>
        // ),
        intakeYear: (
          <MDBox sx={{ px: 1, textAlign: "center", minWidth: 150 }}>
            {(item?.intakeYear || item?.attendee?.checkIn?.intakeYear) && (
              <MDTypography display="block" variant="caption" noWrap>
                {item?.intakeYear || item?.attendee?.checkIn?.intakeYear}
              </MDTypography>
            )}
          </MDBox>
        ),
        lead: (
          <MDBox sx={{ px: 1 }}>
            {item?.leadType && (
              <MDBadge
                badgeContent={item?.leadType}
                color={leadColors[item?.leadType?.toLowerCase().replace(/\s+/g, "_")]}
                variant="gradient"
                size="sm"
                // sx={{ cursor: "pointer" }}
                circular
              ></MDBadge>
            )}
          </MDBox>
        ),
        counselled: (
          <MDBox sx={{ px: 1 }}>
            <MDTypography
              display="block"
              variant="caption"
              fontWeight="medium"
              noWrap
              color={item?.attendee?.counselled ? "info" : "secondary"}
            >
              {item?.attendee?.counselled ? "Yes" : "No"}
            </MDTypography>
          </MDBox>
        ),
        note: (
          <MDBox sx={{ px: 1, textAlign: "left" }}>
            <MDTypography display="block" variant="caption" noWrap>
              {item?.notes}
            </MDTypography>
          </MDBox>
        ),
        // actions: (
        //   <MDBox sx={{ px: 1 }} onClick={(e) => handleAction(e, item?._id)}>
        //     <MDTypography
        //       component="a"
        //       variant="caption"
        //       color="secondary"
        //       fontWeight="medium"
        //       sx={{ cursor: "pointer" }}
        //     >
        //       <Icon fontSize="small">arrow_forward</Icon>
        //     </MDTypography>
        //   </MDBox>
        // ),
      })
    );

    return rowsData;
  }, [list]);

  const handleApplyFilter = () => {
    if (page === 1) {
      getAllCheckInApi();
    } else {
      setPage(1);
    }
  };
  const handleResetFilter = useCallback(() => {
    setLocation(arrLocation[0]);
    setIntake(arrIntake[0]);
    setLeadType(arrLead[0]);
    setStartDate("");
    setEndDate("");
    setCounselled(arrStatus[0]);

    getAllCheckInApi(true);
  }, [arrIntake, arrLocation, arrLead]);

  const handleExport = () => {
    getAllCheckInApi(false, true);
    // exportToExcel(list, "checkIn.xlsx");
  };

  const ViewFilter = useMemo(() => {
    return (
      <Card sx={{ mb: 3 }}>
        <MDBox
          p={3}
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          flexWrap="wrap"
          gap={2}
        >
          {/* Start Date */}
          <MDBox sx={{ width: { xs: "100%", sm: "200px" } }}>
            <MDInput
              type="date"
              label="Start Date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              fullWidth
              InputProps={{ sx: { height: "44px" } }}
              InputLabelProps={{ shrink: true }}
            />
          </MDBox>

          {/* End Date */}
          <MDBox sx={{ width: { xs: "100%", sm: "200px" } }}>
            <MDInput
              type="date"
              label="End Date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              fullWidth
              InputProps={{ sx: { height: "44px" } }}
              InputLabelProps={{ shrink: true }}
            />
          </MDBox>

          {/* Intake Year */}
          <MDBox sx={{ width: { xs: "100%", sm: "200px" } }}>
            <MDInput
              select
              label="Intake Year"
              value={JSON.stringify(intake)}
              onChange={(e) => setIntake(JSON.parse(e.target.value))}
              fullWidth
              InputProps={{ sx: { height: "44px" } }}
              SelectProps={{
                MenuProps: {
                  PaperProps: { style: { maxHeight: 200, maxWidth: 200 } },
                },
              }}
            >
              {arrIntake.map((item) => (
                <MenuItem key={item?.key} value={JSON.stringify(item)}>
                  {item?.name}
                </MenuItem>
              ))}
            </MDInput>
          </MDBox>

          {/* Location */}
          <MDBox sx={{ width: { xs: "100%", sm: "200px" } }}>
            <MDInput
              select
              label="Location Name"
              value={JSON.stringify(location)}
              onChange={(e) => setLocation(JSON.parse(e.target.value))}
              fullWidth
              InputProps={{ sx: { height: "44px" } }}
              SelectProps={{
                MenuProps: {
                  PaperProps: { style: { maxHeight: 200, maxWidth: 200 } },
                },
              }}
            >
              {arrLocation.map((item) => (
                <MenuItem key={item._id} value={JSON.stringify(item)}>
                  {item?.name}
                </MenuItem>
              ))}
            </MDInput>
          </MDBox>

          {/* Lead Type */}
          <MDBox sx={{ width: { xs: "100%", sm: "200px" } }}>
            <MDInput
              select
              label="Lead Type"
              value={JSON.stringify(leadType)}
              onChange={(e) => setLeadType(JSON.parse(e.target.value))}
              fullWidth
              InputProps={{ sx: { height: "44px" } }}
              SelectProps={{
                MenuProps: {
                  PaperProps: { style: { maxHeight: 200, maxWidth: 200 } },
                },
              }}
            >
              {arrLead.map((item) => (
                <MenuItem key={item?.key} value={JSON.stringify(item)}>
                  {item?.name}
                </MenuItem>
              ))}
            </MDInput>
          </MDBox>

          {/* Counselled */}
          <MDBox sx={{ width: { xs: "100%", sm: "200px" } }}>
            <MDInput
              select
              label="Counselled Status"
              value={JSON.stringify(counselled)}
              onChange={(e) => setCounselled(JSON.parse(e.target.value))}
              fullWidth
              InputProps={{ sx: { height: "44px" } }}
              SelectProps={{
                MenuProps: {
                  PaperProps: { style: { maxHeight: 200, maxWidth: 200 } },
                },
              }}
            >
              {arrStatus.map((item) => (
                <MenuItem key={item?.key} value={JSON.stringify(item)}>
                  {item?.name}
                </MenuItem>
              ))}
            </MDInput>
          </MDBox>

          {/* Country */}
          <MDBox sx={{ width: { xs: "100%", sm: "200px" } }}>
            <MDInput
              label="Preferred Country"
              value={country}
              onChange={(e) => setCountry(e.target.value)}
              fullWidth
              InputProps={{ sx: { height: "44px" } }}
            />
          </MDBox>
        </MDBox>

        {/* Action Buttons */}
        <MDBox
          mb={3}
          ml={3}
          mr={3}
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          gap={2}
        >
          <MDBox display="flex" flexDirection={{ xs: "column", sm: "row" }} gap={2}>
            <MDButton onClick={handleApplyFilter} variant="gradient" color="info">
              apply
            </MDButton>
            <Button onClick={handleResetFilter} color="error" variant="contained">
              reset
            </Button>
          </MDBox>
          <MDButton onClick={handleExport} color="secondary" variant="contained">
            export
          </MDButton>
        </MDBox>
      </Card>
    );
  }, [
    startDate,
    endDate,
    intake,
    location,
    leadType,
    counselled,
    country,
    arrIntake,
    arrLocation,
    arrLead,
    arrStatus,
    handleApplyFilter,
    handleResetFilter,
    handleExport,
  ]);

  return (
    <MDBox>
      {/* <ViewFilter /> */}
      {ViewFilter}
      <Card>
        <MDBox p={3} sx={{ width: "100%", overflowX: "auto" }}>
          <DataTable
            table={{ columns, rows }}
            isSorted={false}
            entriesPerPage={false}
            showTotalEntries={true}
            canSearch={true}
            onSearch={onSearchData}
            page={page}
            limit={limit}
            total={total}
            onPageChange={(newPage) => setPage(newPage)}
          />

          {loading && (
            <MDBox display="flex" justifyContent="center" mt={2}>
              <CircularProgress size={24} color="info" />
            </MDBox>
          )}
        </MDBox>
      </Card>
    </MDBox>
  );
}
